var generateStyle = function generateStyle(componentTheme) {
  return {
    uploadIconContainer: {
      color: componentTheme.uploadIconContainerColor,
      fontSize: componentTheme.uploadIconContainerColorFontSize,
      textAlign: 'right'
    },
    checkIconContainer: {
      color: componentTheme.checkIconContainerColor,
      fontSize: componentTheme.checkIconContainerFontSize,
      textAlign: 'right'
    },
    smallText: {
      padding: "0 ".concat(componentTheme.smallTextPadding),
      fontSize: componentTheme.smallTextFontSize,
      color: componentTheme.smallTextColor
    },
    selector: {
      marginTop: componentTheme.selectorMargin
    },
    fileListSuccess: {
      color: componentTheme.fileListSuccessColor
    }
  };
};
export default generateStyle;